import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE404 } from 'framework/api';
import { CreateForm } from 'framework/form';
import EF1Form from 'domain/gpo/externalForm/ef1/create/EF1Form';
import useEF1Service from 'domain/gpo/externalForm/ef1/ef1Service';
import { useExternalFormId } from 'domain/gpo/externalForm/externalFormRoute';
import EF1CreatePageLayout from 'domain/gpo/externalForm/ef1/create/EF1CreatePageLayout';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { INITIAL_FORM_DATA } from 'domain/shared/core/externalForm';
import { isPolishOffice } from 'domain/shared/employee';

const FORM_SUBMISSION_ERROR = "An error occured. Form wasn't submitted.";

const EF1CreatePage = () => {
  const navigate = useNavigate();
  const id = useExternalFormId()!;
  const { addMessage, cleanMessage } = useMessageService();
  const [isFormVisible, setIsFormVisible] = useState(true);
  const [isErrorButtonVisible, setIsErrorButtonVisible] = useState(false);

  const hideForm = () => {
    setIsFormVisible(false);
  };

  const { getDataById, setData, getValidationSchema, validateAlias } = useEF1Service({ hideForm });

  const isValidFormAlias = validateAlias(id);

  const isNotPolishOfficeHandler = (formData: any) => {
    return !isPolishOffice(formData.additionalInfo?.office);
  };

  React.useEffect(() => {
    if (!isValidFormAlias) {
      navigate(ROUTE404);
    }
  }, [isValidFormAlias, navigate]);

  const returnToForm = () => {
    cleanMessage();
    setIsFormVisible(true);
    setIsErrorButtonVisible(false);
  };

  const handleErrorsOnSubmit = () => {
    addMessage(new ErrorMessage(FORM_SUBMISSION_ERROR));
    setIsErrorButtonVisible(true);
    setIsFormVisible(false);
  };

  return (
    <CreateForm
      initialData={INITIAL_FORM_DATA}
      getDataFunc={() => getDataById(id)}
      getValidationSchemaFunc={getValidationSchema}
      submitFormFunc={(data: any) => setData(id, data)}
      afterSubmit={{
        execute: hideForm,
        message: 'You are awesome! Form was successfully submitted.',
      }}
      handleErrorsOnSubmit={handleErrorsOnSubmit}
    >
      <EF1CreatePageLayout
        isFormVisible={isFormVisible}
        isErrorButtonVisible={isErrorButtonVisible}
        returnToForm={returnToForm}
      >
        <EF1Form isNotPolishOffice={isNotPolishOfficeHandler} />
      </EF1CreatePageLayout>
    </CreateForm>
  );
};

export default EF1CreatePage;
